const getTrackPayload = (eventKey, properties) => ({
  eventKey,
  eventProperties: properties || {}
});
export default getTrackPayload;